import React from 'react';

import { StringsDisplay } from '../../Fields';
import { StringsReadOnlyViewProps } from '../types';
import { PII_FIELD_MASKING_CLASS } from '@funnels/constants';

export const ExpenseOwnershipReadOnlyView = (props: StringsReadOnlyViewProps) => {
  const { value, ...rest } = props;

  return <StringsDisplay {...rest} values={value} className={PII_FIELD_MASKING_CLASS} />;
};
